import { render, staticRenderFns } from "./TeacherAttenBigScreenView.vue?vue&type=template&id=cdbd2f98&scoped=true"
import script from "./TeacherAttenBigScreenView.vue?vue&type=script&lang=js"
export * from "./TeacherAttenBigScreenView.vue?vue&type=script&lang=js"
import style0 from "./TeacherAttenBigScreenView.vue?vue&type=style&index=0&id=cdbd2f98&prod&scoped=true&lang=css"
import style1 from "./TeacherAttenBigScreenView.vue?vue&type=style&index=1&id=cdbd2f98&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdbd2f98",
  null
  
)

export default component.exports